/**
 * Format a date value as DD/MM/YYYY for UI and PDF display.
 * Accepts Date, ISO datetime, or YYYY-MM-DD strings.
 */
export function formatDateDDMMYYYY(value) {
  if (value == null || value === '') return '';

  let year;
  let month;
  let day;

  if (typeof value === 'string') {
    const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnly) {
      year = Number(dateOnly[1]);
      month = Number(dateOnly[2]);
      day = Number(dateOnly[3]);
    } else {
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return '';
      year = parsed.getFullYear();
      month = parsed.getMonth() + 1;
      day = parsed.getDate();
    }
  } else if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    year = value.getFullYear();
    month = value.getMonth() + 1;
    day = value.getDate();
  } else {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '';
    year = parsed.getFullYear();
    month = parsed.getMonth() + 1;
    day = parsed.getDate();
  }

  const dd = String(day).padStart(2, '0');
  const mm = String(month).padStart(2, '0');
  const yyyy = String(year);
  return `${dd}/${mm}/${yyyy}`;
}
